import { ShopType, CheckoutType, MultiProviderConfig } from 'types';
import { trialPartnerAsyncEligible } from 'config/sharedFunctions';
import { ProviderConfigList } from 'config/providers';
import { RealPageTheme } from 'config/themes';

export const RealPageEmbed: MultiProviderConfig = {
  name: 'RealPageEmbed',
  displayName: 'RealPage',
  micrositeCode: 'RealPageEmbed',
  shopType: ShopType.MULTI_PROVIDER,
  domain: 'updater.com',
  homepage: '',
  title: 'Compare and shop for internet with RealPage',
  fallbackPhoneNumber: '855-505-1149',
  fallbackLeadModePhoneNumber: '855-505-1148',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: RealPageTheme,
  needsDcSession: false,
  updaterCrossSellActive: false,
  source: 'RealPageEmbed',
  noOffersRetry: 2,
  providers: ProviderConfigList,
  getCheckoutType: trialPartnerAsyncEligible,
  movingAppBuyflowUrls: {
    development: 'http://bridgevine.io:3000/guest/tvi/buy',
    staging: 'https://staging-partner-cart.updater.com/guest/tvi/buy',
    qa: 'https://staging-partner-cart.updater.com/guest/tvi/buy',
    production: 'https://partner-cart.updater.com/guest/tvi/buy',
  },
  iFrameConfig: {
    hideHeaderAndFooter: true,
    trustedHosts: {
      production: ['*.realpage.com', '*.loftliving.com'],
    },
  },
};
